export default "__VITE_ASSET__b7808635__"